/** KPI tile. A value is never shown without its context line. */

import type { ReactNode } from 'react';

interface Props {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  badge?: ReactNode;
  tone?: 'default' | 'warning' | 'critical';
}

export function KpiCard({ label, value, hint, badge, tone = 'default' }: Props) {
  return (
    <section className={`kpi kpi--${tone}`}>
      <h3 className="kpi__label">{label}</h3>
      <p className="kpi__value">{value}</p>
      {badge ? <div className="kpi__badge">{badge}</div> : null}
      {hint ? <p className="kpi__hint">{hint}</p> : null}
    </section>
  );
}
